module.exports = "<form id=\"totpAuthenticationDialogForm\" action=\"javascript:void(0);\">\n    <div class=\"scrollContent\">\n        <div class=\"totpChallengeResponse namespace\"></div>\n        <ul data-role=\"listview\" class=\"attrList\"></ul>\n    </div>\n    <div data-type=\"horizontal\" data-role=\"controlgroup\">\n        <a class=\"attribsDialogContinueBtn\" href=\"#\" data-role=\"button\" data-i18n=\"common::continue.title\"></a>\n    </div>\n</form>";


//////////////////
// WEBPACK FOOTER
// /jenkins/workspace/CudaLaunch_release_production/~/html-loader!./settings/totp/totp_authentication_dialog.html
// module id = 100
// module chunks = 0 3